import React from 'react';
import AppLayout from '../components/AppLayout';
import VendorIntelligenceDashboard from '../components/analytics/VendorIntelligenceDashboard';

export default function VendorIntelligencePage() {
  return (
    <AppLayout>
      <VendorIntelligenceDashboard />
    </AppLayout>
  );
}
